

import { Component, Vue, Prop } from 'vue-property-decorator';
import ContentDownloader from '~common-components/Popup/Common/ContentDownloader.vue';
import ContentFilter from '~common-components/Popup/Common/ContentFilter.vue';

@Component({
    components: {
        ContentDownloader,
        ContentFilter,
    },
})
export default class DumpTemplateHeader extends Vue {
    @Prop() fileData!: string;
    @Prop() fileName!: string;
}
